export const PHONE_NUMBER_REGEX = /^(?:\+61|0)(?:\s*\d\s*){1,10}$/;

// The above PHONE_NUMBER_REGEX allows variable length phone numbers. This is strict.
export const PHONE_NUMBER_REGEX_2 = /^(\+?61|0)(\s*\d){9}$/;
